<template>
    <div id="app">
        <div class="content">
            <div id="experience_container" v-bind:class="{ 'player-loading': !isPlayerVisible }">
                <div class="left-side">
                    <DynamicPanels v-bind:firstName="params.get('firstName')" v-bind:apptDate="params.get('apptDate')" v-bind:apptLocation="params.get('apptLocation')" v-bind:apptTime="params.get('apptTime')" />
                </div>
                <div class="right-side">
                    <div class="right-top">
                        <SessionTracker :panelState="panelState" />
                    </div>
                    <div class="right-bottom">
                        <div id="cb_player_container"></div>
                        <div id="scv_container"></div>
                    </div>
                </div>
                <ConversationView :firstName="params.get('firstName')" />
                <div class="overlays" v-if="!cbLoaded || !experienceStarted">
                    <div class="loading" v-if="!cbLoaded">
                        <div class="loading-wheel">
                            <div class="spinner"></div>
                        </div>
                    </div>
                    <div class="click-to-play" v-if="!experienceStarted && cbLoaded">
                        <div class="start-btn" v-on:click="startExperience">
                            <span class="totally-not-codebaby-icon tnc-icon-play"></span>
                        </div>
                    </div>
                    <div class="load-screen-image-container">
                        <img :src="loadScreenImage" id="load-screen-image">
                    </div>
                </div>
            </div>
        </div>
        <footer>
            <!-- <img src="./assets/images/ida-white.png" alt="iDAvatars" width="120px"> -->
            <img src="@/assets/images/avo-logo.png" alt="AVO Health" width="75px" id="logo">
            <address>
                <div class="address-container">
                    3101 Clairmont Rd. Unit A, Atlanta, Georgia 30329 <br />
                    404-985-6209 &nbsp; info@avohealth.net
                </div>
            </address>
            <div class="disclaimer-container">
                <div class="legal-disclaimer">
                    The text, graphics, images and information (“Content”) on this website are for informational purposes only. Content provided by you will be forwarded to the organization or provider who requested this information from you and is not a substitute for professional medical advice, diagnosis, or treatment for any health condition. Always seek the advice of your medical professional if you have any questions or concerns about your health.
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    // @ is an alias to /src
    import DynamicPanels from '@/components/DynamicPanels.vue'
    import SessionTracker from '@/components/SessionTracker.vue'
    import ConversationView from '@/components/ConversationView.vue'
    import panelState from '@/stores/panelState.js'
    import response from '@/stores/response.js'
    import scenes from '@/stores/scenes.js'



export default {
    created: function() {
        console.log('app created');
        this.$root.$on('player-visible', this.playerVisible);
        if(window.CodeBaby && window.CodeBaby.readyForVue) {
            this.registerCodeBaby(window.CodeBaby);
        } else {
            console.log('listening for CodeBaby');
            this.$root.$on('registerCodeBaby', this.registerCodeBaby);
        }
        let uri = window.location.search.substring(1); 
        this.params = new URLSearchParams(uri);
    },
    mounted: function() {
    },
    data: function() {
        var date = new Date();
        return {
            isPlayerVisible: false,
            cbLoaded: false,
            experienceStarted: false,
            curDate: date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),//'Tuesday, January 18, 2019',
            curTime: date.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false }),//'16:40'
            panelState: panelState,
            response: response,
            params: {},
            scenes: scenes,
            loadScreenImage: require('@/assets/images/LoadScreen.png')
        }
    },
    methods: {
        registerCodeBaby: function(CB) {
            var self = this;
            console.log('CB registered');
            self.CB = CB;
            self.cbLoaded = true;
            var deviceType = CodeBaby.util.getDeviceType();
            if (deviceType != 'desktop') CodeBaby.jQuery('.overlays').html('Your device is not currently supported. We apologize for any inconvienence. Please load this site from a desktop or laptop.');
        },
        startExperience: function() {
            if(!this.CB) return false;

            this.CB.fire('Start Experience');
            this.experienceStarted = true;
        },
        playerVisible: function(visible) {
            this.isPlayerVisible = visible;
        }
    },
    components: {
        DynamicPanels,
        SessionTracker,
        ConversationView
    }
}
</script>
<style lang="stylus">
@keyframes rotate
    0%
        trasform: rotate(0deg)
    50%
        transform: rotate(180deg)
    100%
        transform: rotate(360deg)

body
    background-color #fff
    margin: 0
    padding: 0
    background-image: url('./assets/images/bg.jpg')
    background-position: left top
    background-attachment: fixed
    background-size: initial
    background-repeat: no-repeat
#app
    font-size: 16px
    font-family Helvetica, Arial, sans-serif
    text-align center
    color #000
.content
#experience_container
    display: flex
    width: 1230px
    height: 600px
    position: relative
    padding: 0 40px 40px 40px
    &.player-loading
        .right-bottom
                background: url('./assets/images/loadingImage_Base.png') center/cover no-repeat
    .left-side
        width: 600px
        padding: 9px 0 19px 0
        background: linear-gradient(rgba(0,0,0, .5), rgba(0,0,0,0))
    .right-side
        flex: 1
        display: flex
        flex-direction: column
        .right-top
            flex: 1
        .right-bottom
            width: 380px
            height: 600px
            position: relative
            #cb_player_container
                width: 450px
                height: 100px
                position: fixed
                top: 50px
                left: 600px
                z-index: 1000
                .codebaby-player
                    position: relative !important
            #scv_container
                position: absolute
                right: -100px
                bottom: -20px
                z-index: 1000
    .overlays
        position: absolute
        top: 0
        left: 0
        width: 1366px
        height: 627px
        background: rgba(0,0,0,0.5)
        z-index: 100000
        color: #fff
        & > div
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
        .loading
            .loading-wheel
                width: 100px
                height: 100px
                background: #dfc384
                border-radius: 100%
                position: relative
                left: -50%
                .spinner
                    width: 100%
                    height: 100%
                    background: url('./assets/images/loadingCircles.png') 100%/100% no-repeat
                    background-position: -1px -1px
                    animation: 2s steps(8) rotate infinite
        .click-to-play
            z-index: 5001
            .start-btn
                width: 100px
                height: 100px
                background: #b5d16d
                border-radius: 100%
                position: relative
                cursor: pointer
                left: -50%
                & > span
                    color: #fff
                    font-size: 4em
                    line-height: 1em
                    position: absolute
                    top: 51%
                    left: 54%
                    transform: translate(-50%, -50%)
address
    text-decoration: none
    font-size: .75em
footer
    text-align: center
    width: 1336px
    #logo
        z-index: 9999        
.disclaimer-container
    align-items: center
    display: flex
    flex: 1
    flex-direction: column
    .legal-disclaimer
        font-size .65em
        max-width: 500px
        z-index: 9999
.load-screen-image-container
    z-index: 5000
    #load-screen-image
        position: absolute
        top: -250px
        left: 0
.address-container
    z-index: 9999    
</style>